import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { VOtpInput } from 'vuetify/components/VOtpInput';

export const vuetify = createVuetify({
  components: {
    VOtpInput,
  }
})
